import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button, Div } from '@drifthq/tide-core'
import CopyToClipboard from 'react-copy-to-clipboard'

import './style.css'

export default class InstallSnippetCard extends Component {
  static propTypes = {
    snippet: PropTypes.string.isRequired,
    className: PropTypes.string,
  }

  state = {
    copied: false
  }

  onCopy = () => {
    this.setState({ copied: true })

    setTimeout(() => {
      this.setState({ copied: false })
    }, 1000)
  }

  render() {
    const { snippet } = this.props
    const { copied } = this.state

    const copyText = copied ? "Copied!" : "Copy"
    return (
      <CopyToClipboard text={snippet} onCopy={this.onCopy}>
        <Div className="install-snippet-card-container">
          <pre className="install-snippet-card-snippet">
            {snippet}
          </pre>

          {copied &&
            <span className="install-snippet-copy-text">
              {copyText}
            </span>
          }

          <Button className="install-snippet-copy-button" size="medium" type="tertiary">Copy Code</Button>
        </Div>
      </CopyToClipboard>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OnboardingInstallSnippetCard/index.js